import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download_staging/69e6d4658485e2001497f5cd/cattlebooks/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69e6d4658485e2001497f5cd/cattlebooks/src/components/Sidebar.tsx");
